import { AsyncPipe, NgClass, PlatformLocation } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NavItemModel, NavModel } from '@libs/shared/models';
import { TrackingGoogleService } from '@libs/shared/tracking';
import { NavManagerService, NavStateService, SliderService } from '../../services';
import { ControlsMobileComponent } from '../controls-mobile/controls-mobile.component';
import { ControlsSlideComponent } from '../controls-slide/controls-slide.component';
import { MenuTreeComponent } from '../menu-tree/menu-tree.component';

@Component({
  selector: 'ui-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ControlsMobileComponent,
    ControlsSlideComponent,
    MenuTreeComponent,
    NgClass,
    AsyncPipe,
  ],
})
export class NavComponent implements OnInit, AfterViewInit {
  @Input() public state!: NavModel;

  public navStateService!: NavStateService;

  public constructor(
    private readonly elementRef: ElementRef,
    public readonly navManager: NavManagerService,
    public readonly sliderService: SliderService,
    private readonly location: PlatformLocation,
    private readonly tracking: TrackingGoogleService,
  ) {
  }

  public get typeClass(): string {
    return this.state.name ?? '';
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    this.sliderService.updateSize();
  }

  public ngOnInit(): void {
    this.navStateService = this.navManager.getService(this.state);
  }

  public ngAfterViewInit(): void {
    this.sliderService.initialize(this.elementRef.nativeElement as HTMLElement);
  }

  public onSelected(item: NavItemModel): void {
    if (this.state.gtmEvent && item.label && item.url) {
      this.tracking.trackNavigationEvent(this.state.gtmEvent, item.label, item.url);
    }

    if (this.navStateService && !this.isExternalLink(item.url)) {
      this.navStateService.switchActive(item);
      this.navStateService.switchExpanded(item);
    }
  }

  private isExternalLink(url?: string): boolean {
    if (!url) {
      return false;
    }

    try {
      return this.location.hostname !== new URL(url).host;
    } catch {
      // We treat all not-parseable strings as internal
      return false;
    }
  }
}
